import React, { useState } from "react";
import matrixData from "../data/matrix_data.json";

const FSCPMatrix = () => {
  const data = matrixData.matrix;

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f4f6f8",
        padding: "20px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0 8px",
          border: "none",
        }}
      >
        <thead>
          <tr
            style={{
              textTransform: "uppercase",
              fontSize: "12px",
              color: "#7c8b9a",
              textAlign: "left",
              border: "none",
            }}
          >
            <th style={{ padding: "8px", border: "none", width: "400px" }}>
              Mapping
            </th>
            <th style={{ border: "none", textAlign: "right" }}>
              Uploaded TB Balance
            </th>
            <th style={{ border: "none", textAlign: "right" }}>Adjustments</th>
            <th style={{ border: "none", textAlign: "right" }}>
              Updated Balance
            </th>
            <th style={{ border: "none" }}>Module</th>
            <th style={{ border: "none" }}>Task</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <MatrixRow key={index} item={item} level={0} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

const MatrixRow = ({ item, level }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const hasSubgroup = item.subgroup && item.subgroup.length > 0;
  const hasLedgers = item.ledgers && item.ledgers.length > 0;

  const canExpand = hasSubgroup || (level === 2 && hasLedgers);

  const levelColors = [
    { background: "#e0f2f1", color: "#00695c" },
    { background: "#e3f2fd", color: "#1565c0" },
    { background: "#fff3e0", color: "#ef6c00" },
    { background: "#ede7f6", color: "#5e35b1" },
  ];

  const badgeText = level < 3 ? `L${level + 1}` : "LE";
  const currentLevel = levelColors[level] || levelColors[3];

  const badgeStyle = {
    fontSize: "10px",
    fontWeight: "bold",
    borderRadius: "12px",
    padding: "4px 8px",
    marginRight: "8px",
    display: "inline-block",
    minWidth: "24px",
    textAlign: "center",
    backgroundColor: currentLevel.background,
    color: currentLevel.color,
    border: "none",
  };

  const rowStyle = {
    backgroundColor: "#ffffff",
    // boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    cursor: canExpand ? "pointer" : "default",
    border: "none",
  };

  const cellStyle = {
    padding: "12px",
    textAlign: "left",
    backgroundColor: "#ffffff",
    border: "none",
  };

  const cardCellStyle = {
    padding: "12px",
    textAlign: "left",
    backgroundColor: currentLevel.background,
    color: currentLevel.color,
    borderRadius: "8px",
    border: "none",
    width: "100%",
  };

  return (
    <>
      <tr style={rowStyle} onClick={() => canExpand && setIsExpanded(!isExpanded)}>
        <td
          style={{
            ...cellStyle,
            paddingLeft: `${level * 24 + 12}px`,
            width: "400px",
            border: "none",
            backgroundColor:"#f4f6f8"
          }}
        >
          <div
            style={{
              ...cardCellStyle,
              display: "flex",
              alignItems: "center",
            }}
          >
            <span style={badgeStyle}>{badgeText}</span>
            <span style={{ flexGrow: 1 }}>{item.name}</span>
            {canExpand && (
              <span style={{ marginLeft: "auto" }}>
                {isExpanded ? "▼" : "▶"}
              </span>
            )}
          </div>
        </td>
        <td style={{ ...cellStyle, textAlign: "right" }}>
          {item.uploadedTBBalance ?? "-"}
        </td>
        <td style={{ ...cellStyle, textAlign: "right" }}>
          {item.adjustmentAmount ?? "-"}
        </td>
        <td style={{ ...cellStyle, textAlign: "right" }}>
          {item.adjustedAmount ?? "-"}
        </td>
        <td style={cellStyle}>Data</td>
        <td style={cellStyle}>Data</td>
      </tr>

      {isExpanded &&
        hasSubgroup &&
        item.subgroup.map((sub, idx) => (
          <MatrixRow key={idx} item={sub} level={level + 1} />
        ))}

      {isExpanded &&
        level === 2 &&
        hasLedgers &&
        item.ledgers.map((ledger, idx) => (
          <tr key={`ledger-${idx}`} style={rowStyle}>
            <td
              style={{
                ...cellStyle,
                paddingLeft: `${(level + 1) * 24 + 12}px`,
                width: "400px",
                backgroundColor:"#f4f6f8"
              }}
            >
              <div
                style={{
                  ...cardCellStyle,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span style={badgeStyle}>LE</span>
                {ledger.name}
              </div>
            </td>
            <td style={{ ...cellStyle, textAlign: "right" }}>
              {ledger.uploadedTBBalance ?? "-"}
            </td>
            <td style={{ ...cellStyle, textAlign: "right" }}>
              {ledger.adjustmentAmount ?? "-"}
            </td>
            <td style={{ ...cellStyle, textAlign: "right" }}>
              {ledger.adjustedAmount ?? "-"}
            </td>
            <td style={cellStyle}>Data</td>
            <td style={cellStyle}>Data</td>
          </tr>
        ))}
    </>
  );
};

export default FSCPMatrix;
